let _ = require("ES/lib/lodash");
let radio = require("ES/lib/radio");
let Balboa = require("ES/services/Balboa");
let AuthedUserSession = require("../utils/AuthedUserSession");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

let dashboard_cache = null;
let dataIsDirty = false;

module.exports.init = function () {
  RadioService("Dashboard_get", function (params, callback) {
    if ((dashboard_cache !== null) && !dataIsDirty) {
      callback(null, dashboard_cache);
      return;
    }
    Balboa.api("/calendar/dashboard", {
      formatdates: true,
      onlysections: [],
      company_id: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
    }, function (data) {
      dashboard_cache = data.data;
      dataIsDirty = false;
      callback(null, dashboard_cache);
    }, function (data) {
      callback((data && data.message) || "unknown cause");
    });
  }, function () {
    return 1;
  });

  radio("save_Event").subscribe(function (event) {
    if (dashboard_cache) {
      // remove old items for this event (so they can be replaced)
      let prev_action_list = _.get(dashboard_cache, ["actionlist"]);
      _.remove(prev_action_list, (action_item) => {
        return _.get(action_item, ["eid"]) === _.get(event, ["eid"]);
      });

      // grab this event's action items & remove ones that are old, belong to another user, or are complete
      let new_action_items = _.get(event, "EventTodo", []);
      _.remove(new_action_items, function (a) {
        let statusdate = new Date(_.get(a, "statusdate_ISO8601"));
        let too_old = (new Date().getTime() - statusdate.getTime()) > 2764800000;
        return too_old || (_.get(a, "status") !== 0) || (AuthedUserSession.MY_USERNAME.localeCompare(a.assignedto, undefined, {sensitivity: "accent"}) !== 0);
      });

      //map the new action items to expected format
      new_action_items = _.map(new_action_items, (event_todo) => ({
          id: _.get(event_todo, ["id"]),
          status: _.get(event_todo, ["status"]),
          psnl: _.get(event, ["isPersonal"]),
          dsc: _.get(event_todo, ["description"]),
          intls: _.get(event, ["initials"]),
          date: _.get(event_todo, ["statusdate_ISO8601"]),
          eid: _.get(event, ["eid"]),
          org: _.get(event, ["organization"]),
          sids: _.get(event, ["sids"])
        })
      );

      // merge the updated event action items with the action list
      let action_list = (prev_action_list).concat(new_action_items);
      _.set(dashboard_cache, ["actionlist"], action_list);
    } else {
      radio("Dashboard_get").broadcast();
    }
  });

  radio("Event_destroy").subscribe(function (event_id) {
    dataIsDirty = true;
  });
};



// WEBPACK FOOTER //
// ./src/services/Dashboard.js